//let mainServer = 'http://localhost:9020';
let mainServer = 'http://49.4.0.68:9020';

let servers = {
  pinger: mainServer + '/pinger',
  liferemaker: mainServer + '/liferemaker',
}

export default servers;